'use client';
import { getQueryClient } from '@/providers/queryClient';
import { BASE_BACKEND_URL, BASE_CHAT_URL } from '@/requests/constants';
import { getChatManager, initChatManager } from '@pigello/pigello-chat';
import { usePathname } from 'next/navigation';
import { useOnMessage } from './use-on-message';
import { getCurrentBranding } from '@/hooks/use-current-branding';
import { useEffect } from 'react';
import { getSessionValues } from '@/providers/session-provider/get-session-values';
import { getSocketToken } from '@/hooks/use-web-socket/get-socket-token';

export default function PigelloChatInit() {
  const pathname = usePathname();
  const isLoginPage = pathname.includes('/login');
  const { setLastMessage } = useOnMessage();
  useEffect(() => {
    if (!BASE_BACKEND_URL || !BASE_CHAT_URL || isLoginPage) {
      return;
    }
    const queryClient = getQueryClient();
    const branding = getCurrentBranding();
    const { restrictedToIpAddress } = getSessionValues();
    const token = getSocketToken();
    const disconnectChatManager = initChatManager({
      queryClient,
      restrictedToIpAddress: restrictedToIpAddress
        ? restrictedToIpAddress
        : undefined,
      token,
      userType: 'accounts.organizationuser',
      socketUrl: BASE_CHAT_URL,
      backendUrl: BASE_BACKEND_URL,
      branding,
      pigelloClientType: `${process.env.NEXT_PUBLIC_CLIENT_TYPE},frontend,1.0.0`,
      onMessage: setLastMessage,
    });

    return () => {
      disconnectChatManager?.();
    };
  }, [isLoginPage, setLastMessage]);

  useEffect(() => {
    function handleVisibilityChange() {
      if (document.visibilityState === 'visible') {
        getChatManager()?.checkConnectionHealth();
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return null;
}
